import { ReasonCodeEntityClass, ReasonCodePrimaryType } from './reason-code-type.enums';
import { IReasonCodeGroupConfig, IReasonCodeType } from './reason-code-type.interfaces';
import { AuditEntityClass } from '../../enum/audit-entity-class.enum';

export class RejectType implements IReasonCodeType {
  readonly entityClass = ReasonCodeEntityClass.ProgramPeriod;
  readonly primaryType = ReasonCodePrimaryType.AuditRejectReason;

  constructor(readonly config: IReasonCodeGroupConfig) {}
}

export const AuditRiskReason = new RejectType({
  secondaryType: AuditEntityClass.AuditRiskEntry,
  statusLabel: '',
  isDefault: true,
});

export const AuditQualityReason = new RejectType({
  secondaryType: AuditEntityClass.AuditQualityEntry,
  statusLabel: '',
  isDefault: true,
});

export const AuditRejectReason = [AuditRiskReason, AuditQualityReason];
